import { uniqueId } from '@comeon/utility';

import { Notification, NotificationAction, NotificationActionType } from './types';

export const showQueuedNotification = (
	notification: Omit<Notification, 'id' | 'shouldOpen'> & { id?: string }
): NotificationAction => {
	return {
		type: NotificationActionType.SHOW_NOTIFICATION,
		payload: {
			id: notification.id || uniqueId(),
			shouldOpen: true,
			...notification
		}
	};
};

export const hideQueuedNotification = (notificationId: string): NotificationAction => {
	return {
		type: NotificationActionType.HIDE_NOTIFICATION,
		payload: notificationId
	};
};
